import { useContext, useEffect, useState } from 'react';
import {
  Fab,
  IconButton,
  Tooltip,
  Typography,
  MenuItem,
} from '@mui/material';

import {
  CompareArrows as CompareArrowsIcon,
} from '@mui/icons-material';

import { getDatabase } from "firebase/database";
import { AuthContext, Product } from 'components';

const db = getDatabase();

// Deep merge from SO. For some reason object assignment join keeps reference and updates the original items
/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}

export const MergeModal = (props) => {
  const { selected, items } = props;
  const [ saving, setSaving ] = useState(false);
  const [ mergedProduct, setMergedProduct ] = useState(false)
  const [ errors, setErrors ] = useState([])
  const { deleteItem } = useContext(AuthContext)

  useEffect(() => {
    if (!selected) return;

    let brands = []
    let photos = []
    let categories = []
    let retail_prices = []
    let cost_prices = []
    let deliveryStartDates = []
    let deliveryEndDates = []
    let colors = []
    let notes = ''
    let quantity = 0

    let errors = []
    let new_item = {}

    items.map(item => {
      if (brands.indexOf(item.brand) === -1) { brands.push(item.brand) }
      if (categories.indexOf(item.categoryId) === -1) { categories.push(item.categoryId) }
      if (item.photos && photos.indexOf(item.photos) === -1) { photos = [...photos, ...item.photos] }
      if (cost_prices.indexOf(item.priceInfo?.price) === -1) { cost_prices.push(item.priceInfo?.price) }
      if (retail_prices.indexOf(item.priceInfo?.price) === -1) { retail_prices.push(item.priceInfo?.price) }
      if (item.priceInfo?.quantity) { quantity = quantity + item.priceInfo?.quantity }
      if (item.deliveryStart && deliveryStartDates.indexOf(item.deliveryStart) === -1) { deliveryStartDates.push(item.deliveryStart) }
      if (item.deliveryEndDate && deliveryEndDates.indexOf(item.deliveryEndDate) === -1) { deliveryEndDates.push(item.deliveryEndDate) }
      if (item.note) { notes = `${notes}${item.note}\n\n` }
      if (item.color) { colors = [...colors, ...item.color] }

      new_item = mergeDeep(new_item, item)
    })

    if (brands.length > 1) { errors.push({ message: 'Cannot merge products with different brands' }) }
    if (categories.length > 1) { errors.push({ message: 'Cannot merge products with different categories' }) }
    if (photos.length > 4) { errors.push({ message: 'Cannot merge products with more than 4 combined photos' }) }
    if (cost_prices.length > 1 || retail_prices.length > 1) { errors.push({ message: 'Cannot merge products with different prices' }) }
    if (deliveryStartDates.length > 1 || deliveryEndDates.length > 1) { errors.push({ message: 'Cannot merge products with different delivery dates' }) }
    if (items.length === 1) { errors.push({ message: 'Select more than 1 item to merge' }) }

    setErrors(errors)

    if (errors.length === 0) {
      new_item = {
        ...new_item,
        create: true,
        color: [...new Set(colors)],
        note: notes,
        photos,
      }

      if(new_item.priceInfo) {
        new_item.priceInfo.quantity = quantity
      }

      setMergedProduct(new_item)
    } else {
      setMergedProduct(false)
    }
  }, [items])

  const handleAction = () => {
    if (errors.length !== 0) {
      return
    }

    let bulk_action = []

    items.forEach((item) => {
      bulk_action.push(new Promise((resolve, rejejct) => {
        deleteItem(item, resolve)
      }))
    })

    Promise.all(bulk_action).then(() => {
      console.log('Merged items deleted')
      setMergedProduct(false)
    })
  };
 
  return (
    <Tooltip title={!selected || (errors.length === 0 && items.length) > 0 ? '' : errors.map(e => <div key={e.message}><Typography variant="info">{e.message}</Typography></div>)}>
      <span>
        <MenuItem sx={{p: 0}} component="div" color={ mergedProduct ? 'info' : 'disabled'} aria-label="merge">
          <Product 
            product={mergedProduct || { create: true }} 
            onCreate={() => { setSaving(true); setTimeout(handleAction, 200) }}
            button={(
              <div style={{width: 153, margin: "6px 16px"}}>Merge</div>
              // <IconButton>
              //   <CompareArrowsIcon sx={{color: mergedProduct ? 'white' : 'default'}} />
              // </IconButton>
            )} 
          />
        </MenuItem>
      </span>
    </Tooltip>
  )
}